import { render, staticRenderFns } from "./ThePageTitleSection.vue?vue&type=template&id=75036eb8&"
import script from "./ThePageTitleSection.vue?vue&type=script&lang=ts&"
export * from "./ThePageTitleSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsTheBreadcrumbs: require('/usr/src/nuxt-app/components/elements/TheBreadcrumbs.vue').default})
